<template>
  <div class="flex-space align-center" v-if="!isImport(item)">
    <popup
      componentPath="components/html"
      width="1200"
      :options="{
        title: 'ETA Details',
        url: '/export_containers/' + item.id + '/erd',
        width: '100%',
      }"
    >
      <i class="el-icon-info"></i>
    </popup>
    <el-date-picker
      size="mini"
      v-model.lazy="item.erd"
      type="date"
      format="MM/dd/yy"
      :value-format="'yyyy-MM-dd'"
      @change="
        $emit('columnEvent', 'autoSave', item, 'early_receiving_date', $event)
      "
      style="width: 90px"
    >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  name: "order-status-erd",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
